import Vue from 'vue'
import axios from 'axios'
import { Style, Toast } from 'cube-ui'
Vue.use(Toast)

// import qs from 'qs'
var pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// let accessToken = window.localStorage.getItem('tokenId')
const CancelToken = axios.CancelToken

var removePending = config => {
  for (let p in pending) {
    if (pending[p].conf === config.url + '&' + config.method) {
      // 当当前请求在数组中存在时执行函数体
      pending[p].func() // 执行取消操作
      pending.splice(p, 1) // 把这条记录从数组中移除
    }
  }
}
// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    removePending(config) // 在一个ajax发送前执行一下取消操作
    config.cancelToken = new CancelToken(c => {
      pending.push({ conf: config.url + '&' + config.method, func: c })
    })
    // 添加请求头
    // config.headers.accessToken = accessToken
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    removePending(response.config) // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    return response
  },
  error => {
    return Promise.reject(error)
    // return { data: error }  // 返回一个空对象，主要是防止控制台报错
  }
)

// 响应中包含错误
async function errorResponse(res, reject, bus) {
  console.log(res)
  console.log(reject)
  console.log(bus)
  bus.$message.error(res.data.msg)
}

/**
 *
 * @param {*请求的URL与方法} api
 * @param {*请求需要发送的数据} data
 * @param {*事件总线，主要是为了vue中的i18n和message} bus
 * @param {*回调函数，在上传中用于回调进度信息} cb
 */
export function requestControl(api, data, cb = () => {}) {
  // let accessToken = window.localStorage.getItem('tokenId')
  switch (api.method.toLowerCase()) {
    case 'post':
      return new Promise((resolve, reject) => {
        axios.post(api.url, data, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          resolve(res)
        })
      })
    case 'postfomdata':
      return new Promise((resolve, reject) => {
        axios.post(api.url, data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(res => {
          resolve(res)
        }).catch(err => {})
      })
    case 'postinfo':
      return new Promise((resolve, reject) => {
        axios.post(api.url, data, {
          headers: {
            'sysCode': 'cus',
            'uToken': localStorage.getItem('userToken')
          }
        }).then(res => {
          resolve(res)
        })
      })
    case 'get':
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: api.url,
          params: data,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          resolve(res)
        }).catch(err => {})
      })
    case 'postdata':
      return new Promise((resolve, reject) => {
        axios.post(api.url, data, {
          headers: {
            'Content-Type': 'application/json',
            ukey: localStorage.getItem('ukey'),
            utoken: localStorage.getItem('utoken')
            // ukey: 'usSsAB49Rg',
            // utoken: 'sSsAB49RgGdm3hQHFPrUif8jPQBFMgKaZvENHb1CoDE.Kv4BTWw3DXichMpT9RDOg5VrDV6Rgq3D3s3pcWjZh4.yPsnOo0dnxKSqI25pa1H62E8RQkxvXnqWJnfuaQ'
          }
        }).then(res => {
          resolve(res)
          // if (res.data.code === 200) {
          //   resolve(res)
          // } else {
          //   console.log(res)
          //   console.log('错误5')
          // }
        })
      })
      case 'postsyscode':
        return new Promise((resolve, reject) => {
          axios.post(api.url, data, {
            headers: {
              'Content-Type': 'application/json',
              sysCode: localStorage.getItem('sysCode'),
              utoken: localStorage.getItem('utoken')
              // ukey: 'u9DeNBRSsX',
              // utoken: '9DeNBRSsXnyIvFb8x8AqRcmlzxTEW1pYAjkIaTAegJU.cvZ6SAMyQhBHXlj8QjGHLyuqxLlVQ1h5OSY5Jqas.if2sjklkE7LMHj4fbySBU774vAceqW8CU2AM4XsZg'
            }
          }).then(res => {
            resolve(res)
            // if (res.data.code === 200) {
            //   resolve(res)
            // } else {
            //   console.log(res)
            //   console.log('错误5')
            // }
          })
        })
    default:
      break
  }
}
